export const tr = {
    'chat-not-found': "Bu ID'ye sahip sohbet yok",
    'text-error': 'Sohbet eklenirken hata oluştu. Lütfen, daha sonra tekrar deneyin.'
};
